import styled from 'styled-components';

export const Thumb = styled.div`
    display: flex;
    flex-direction: column;
    text-decoration: none !important;
    cursor: pointer;
    height: 100%;
`;

export const Top = styled.div`
    width: 100%;
    height: auto;
    padding-top: 50%;
    background-color: ${props => props.theme.colors.gray};
    background-size: cover;
    background-position: center center;
    background-image: url(${props => props.photo});
    border-radius: 5px 5px 0 0;
`;

export const Chin = styled.div`
    background-color: ${props => props.theme.colors.midGray};
    padding: 12px 15px;
    color: #fff;
    flex-grow: 1;
    text-decoration: none;
    border-radius: 0 0 5px 5px;
`;